import {
    ApartmentOutlined,
    ClockCircleOutlined,
    CloseCircleFilled,
    FlagFilled,
    PrinterFilled,
} from '@ant-design/icons'
import { theme, Tooltip, Typography } from 'antd'
import { FC, ReactNode } from 'react'
import PrintJob, { CancelationReasons, JobStatuses } from '../../../../../types/api/print-job'
import {
    getPrintStatusDisplay,
    getPrintStatusTooltip,
    PrintStatusDisplay,
} from '../../../helpers/get-print-status-display'

interface PrintStatusProps {
    printJob: PrintJob
}

function getCancelationReasonText(printJob: PrintJob): string | null {
    if (printJob.jobStatus !== JobStatuses.Cancelled) return null

    const reason =
        printJob.cancelationReason === CancelationReasons.Other
            ? printJob.otherCancelationReason
            : printJob.cancelationReason

    return reason || null
}

const PrintStatus: FC<PrintStatusProps> = ({ printJob }) => {
    const { token } = theme.useToken()
    const displayStatus = getPrintStatusDisplay(printJob.jobStatus)

    if (!displayStatus) return null

    const iconSize = '16px'
    const cancelReason = getCancelationReasonText(printJob)

    const icons: Record<PrintStatusDisplay, ReactNode> = {
        [PrintStatusDisplay.InDistribution]: (
            <ApartmentOutlined style={{ color: token.geekblue5, fontSize: iconSize }} />
        ),
        [PrintStatusDisplay.InMachineQueue]: (
            <ClockCircleOutlined style={{ color: token.blue5, fontSize: iconSize }} />
        ),
        [PrintStatusDisplay.InProgress]: (
            <PrinterFilled style={{ color: token.magenta5, fontSize: iconSize }} />
        ),
        [PrintStatusDisplay.Completed]: (
            <FlagFilled style={{ color: token.green5, fontSize: iconSize }} />
        ),
        [PrintStatusDisplay.Cancelled]: (
            <CloseCircleFilled style={{ color: token.red5, fontSize: iconSize }} />
        ),
    }

    return (
        <Tooltip title={getPrintStatusTooltip(displayStatus, printJob)} placement={'right'}>
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                {icons[displayStatus]}
                {cancelReason && (
                    <Typography.Text type='danger' style={{ fontSize: 12, maxWidth: 140 }} ellipsis>
                        {cancelReason}
                    </Typography.Text>
                )}
            </span>
        </Tooltip>
    )
}

export default PrintStatus
